import { useEffect } from 'react'
import { useIntl } from 'react-intl'

import { useAppSelector, useAppDispatch } from 'app/state'
import { checkAccountIsReadyStatusRequest, retryWhileAccountIsNotReadyRequest } from 'features/users/state/usersSlice'
import workspaceVectorUrl from 'assets/img/carto-logo-positive.svg'
import SplashLoading from 'features/common/ui/Loaders/SplashLoading'
import { AccountCreationProcess } from 'features/users/types'

function AccountCreationLoading() {
  const dispatch = useAppDispatch()
  const intl = useIntl()

  const user = useAppSelector((state) => state.users.me)
  const accountIsReadyStatus = useAppSelector((state) => state.users.accountIsReadyStatus)

  useEffect(() => {
    if (user) {
      // 1st check
      dispatch(checkAccountIsReadyStatusRequest(user.user_metadata.account_id))
    }
  }, [dispatch, user])

  useEffect(() => {
    if (user && accountIsReadyStatus === AccountCreationProcess.IsBeingCreated) {
      // 2nd check, start polling for account status creation to finish
      dispatch(retryWhileAccountIsNotReadyRequest(user.user_metadata.account_id))
    }
  }, [dispatch, user, accountIsReadyStatus])

  if (accountIsReadyStatus === AccountCreationProcess.IsBeingCreated) {
    return (
      <SplashLoading
        imageUrl={workspaceVectorUrl}
        message={intl.formatMessage({ id: 'account.isBeingCreated.description' })}
        title={intl.formatMessage({ id: 'account.isBeingCreated.title' })}
      />
    )
  }

  return null
}

export default AccountCreationLoading
